import React, { useState } from 'react';

import Modal from 'react-bootstrap/Modal';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ConfirmButton from '../../components/Buttons/ConfirmButton';
import Thumbnails from './Thumbnails';

import classes from './styles.module.scss';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import closeIcon from '../../assets/images/closeIconBlack.svg';
import closeIconWhite from '../../assets/images/closeIconWhite.svg';

const buttonSvg = (
  <svg
    width="19"
    height="37"
    viewBox="0 0 19 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.79902 18.5L19 34.5006L17.1005 36.5L0 18.5L17.1005 0.5L19 2.49937L3.79902 18.5Z"
      fill="white"
    />
  </svg>
);

export default function ViewImageSectionModal({ show, handleClose, images }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMobile = useCheckMobileScreen();

  const switchNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images?.length - 1 ? 0 : prevIndex + 1
    );
  };

  const switchPrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images?.length - 1 : prevIndex - 1
    );
  };

  const thumbnails = (
    <Thumbnails
      currentImageIndex={currentImageIndex}
      setCurrentImageIndex={setCurrentImageIndex}
      images={images}
    />
  );

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.ViewImageSectionModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      <button
        type="button"
        className={classes.closeButton}
        onClick={() => handleClose({ shouldContinue: false })}
      >
        <img src={isMobile ? closeIcon : closeIconWhite} alt="close" />
      </button>

      <div className={classes.container}>
        <div className={classes.imageContainer}>
          {images?.length > 1 ? (
            <button
              type="button"
              className={classes.switchButton}
              onClick={switchPrev}
            >
              {buttonSvg}
            </button>
          ) : null}
          <img
            src={images?.[currentImageIndex].signedS3Url}
            className={classes.image}
            alt="section"
          />
          {images?.length > 1 ? (
            <button
              type="button"
              className={classes.switchButton}
              onClick={switchNext}
            >
              {buttonSvg}
            </button>
          ) : null}
        </div>

        {isMobile && thumbnails}

        <footer className={classes.footer}>
          <div className={classes.textContainer}>
            <h2 className={classes.filename}>
              {images[currentImageIndex].fileName}
            </h2>
            {images[currentImageIndex]?.description && (
              <p className={classes.text}>
                {images[currentImageIndex].description}
              </p>
            )}
          </div>
          <div className={classes.buttons}>
            <ConfirmButton width={isMobile ? 60 : 70} onClick={handleClose} />
          </div>
        </footer>
      </div>
      {!isMobile && thumbnails}
    </Modal>
  );
}
